export enum CatType {
    Device = 'מכשיר',
    Accessory = 'אביזר',
    Consumable = 'מתכלה',
    SparePart = 'חלק חילוף',
}

export interface SupplierSummary {
    _id: string;
    name: string;
}

export enum MaintenanceMethod {
    PeriodicTestAndCalibration = 'בדיקה תקופתית וכיול',
    MalfunctionMaintenance = 'אחזקת שבר',
    NoMaintenance = 'ללא אחזקה',
}

export type NumericRange = { min?: number | null, max?: number | null };

export type AbbreviatedItem = { _id?: string, name: string, cat: string, catType?: CatType, kitCats?: string[]; imageLink?: string, manufacturer?: string, archived?: boolean, createdAt?: string, supplier?: SupplierSummary };
export type Item = {
    _id: string,
    name: string,
    cat: string,
    kitCats?: string[],
    sector: string,
    department: string,
    catType: CatType,
    certificationPeriodMonths?: number,
    description: string,
    imageLink?: string,
    qaStandardLink?: string,
    medicalEngineeringManualLink?: string;
    userManualLink?: string,
    serviceManualLink?: string,
    hebrewManualLink?: string,
    schemasLink?: string,
    emergency?: boolean,
    maintenanceMethod: MaintenanceMethod,
    maintenanceIntervalMonths?: number,
    storageTemperature?: NumericRange,
    storageHumidity?: NumericRange,
    minimumStock?: number,
    supplier?: SupplierSummary,
    price?: number,
    lifeSpan?: string,
    models?: AbbreviatedItem[],
    accessories?: AbbreviatedItem[],
    consumables?: AbbreviatedItem[],
    spareParts?: AbbreviatedItem[],
    belongsToDevices?: AbbreviatedItem[],
    archived?: boolean;
};
